import { useEffect, useRef, useState } from "react";
import "./leads.css";
import Cookies from "js-cookie";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { CONTACTAGENTLIST_URL, DELETECONTACTAGENT_URL } from "../../global/API";
// import Pagination from "rc-pagination";
import Swal from "sweetalert2";
import { Calendar } from "primereact/calendar";
import { format } from "date-fns";
import EditLead from "../../components/editLead/editLead";
import { Tooltip } from "primereact/tooltip";
import CustomModal from "../../components/customModal/customModal.js";
import Editor from "quill/core/editor.js";
import { Image } from "primereact/image";
import CustomTable from "../../components/customTable/customTable.js";

const customModules = {
  toolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }], [{ align: [] }], ["link", "image"]],
  // toolbar: [[{ header: [1, 2, 3, false] }], ["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }], [{ align: [] }], ["link", "image"], ["clean"]],
};

const agentHeaderList = ["Agent Photo & Name", "Agent Title", "Email", "Cell Phone", "Office Phone", "Action"];

const Leads = () => {
  const [leadsList, setLeadsList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [changeType, setChangeType] = useState("");
  const [selectedContact, setSelectedContact] = useState(null);
  const [viewLead, setViewLead] = useState([]);
  const [paginationObj, setPaginationObj] = useState({ pageSize: 30, current: 1 });
  const [filteredValues, setFilteredValues] = useState({ searchValue: null });
  const [dates, setDates] = useState(null);
  const [getModalLayout, setGetModalLayout] = useState(null);

  // const viewLeadModalRef = useRef();
  const navigate = useNavigate();

  // const { "*": leadParam } = useParams();
  // const activeLeadId = useMemo(() => leadParam?.split("/") || [], [leadParam]);
  // const leadIdArr = activeLeadId[1]?.split(",");

  const [selectedLeads, setSelectedLeads] = useState([]);

  const [activityTab, setActivityTab] = useState(1);

  const onHandleselectedList = (id, event) => {
    const newList = id;
    if (event.target.checked) {
      setSelectedLeads((preState) => [...preState, newList]);
    } else {
      const filteredListing = selectedLeads.filter((item) => item !== id);
      setSelectedLeads(filteredListing);
    }
  };

  const fetchData = async (current, pageSize = paginationObj.pageSize) => {
    const { searchValue } = filteredValues;
    setIsLoading(true);
    const jwtToken = Cookies.get("jwtToken");
    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${jwtToken}` },
    };
    // &cfdate=${dates[0]}&ctdate=${dates[1]}
    // ${formattedFromDate !== false ? formattedFromDate : ""}
    // cfdate=${formattedFromDate}&ctdate=${formattedToDate}
    const URL =
      CONTACTAGENTLIST_URL +
      `?limit=${pageSize}&page=${current}&type=${changeType}&search=${searchValue || ""}&${
        dates ? (dates[1] ? `cfdate=${format(new Date(dates[0]), "yyyy-MM-dd")}&ctdate=${format(new Date(dates[1]), "yyyy-MM-dd")}` : `cdate=${format(new Date(dates[0]), "yyyy-MM-dd")}`) : ""
      }`;
    try {
      const response = await fetch(URL, options);
      if (response.ok) {
        const data = await response.json();
        setLeadsList(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = (...id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const jwtToken = Cookies.get("jwtToken");
        const options = {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        };

        try {
          const response = await fetch(DELETECONTACTAGENT_URL + `${id}`, options);
          if (response.ok) {
            Swal.fire({
              title: "Deleted!",
              text: "Your file has been deleted.",
              icon: "success",
            });
            setSelectedLeads([]);
            fetchData(paginationObj.current, paginationObj.pageSize);
          } else {
            console.error("Failed to delete contact");
          }
        } catch (error) {
          console.error("Error deleting contact:", error);
        }
      }
    });
  };

  useEffect(() => {
    fetchData(paginationObj.current, paginationObj.pageSize);
  }, [paginationObj]);

  useEffect(() => {
    const { searchValue } = filteredValues;
    if (searchValue?.length >= 3 || searchValue === "") {
      const timeout = setTimeout(() => {
        fetchData(1, paginationObj.pageSize);
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [filteredValues.searchValue]);

  const filterGrid = (e) => {
    const { name, value } = e.target;
    setFilteredValues({
      ...filteredValues,
      [name]: value,
    });
  };

  useEffect(() => {
    if (changeType !== "" || dates) {
      fetchData(1, paginationObj.pageSize);
    }
  }, [changeType, dates]);

  useEffect(() => {
    if (getModalLayout === 2) {
      setActivityTab(0);
    } else {
      setActivityTab(1);
    }
  }, [getModalLayout]);

  const paginationChange = (current, pageSize) => {
    setPaginationObj({ ...paginationObj, current });
    fetchData(current, pageSize);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // useEffect(() => {
  //   if (activeLeadId[0] === "lid" && activeLeadId[1] && leadsList.status === "Success") {
  //     const filteredLead = leadsList.data.filter((lead) => leadIdArr.includes(lead.id.toString()));
  //     setViewLead(filteredLead);
  //   } else {
  //     setViewLead([]);
  //   }
  // }, [activeLeadId, leadsList]);

  const onLidClose = () => {
    navigate("/leads");
    setViewLead(null);
  };

  const renderLeadDetails = (item) => {
    const { id, listing_id, address, cityName, agentFirstName, agentLastName, property_image, name, phone, email, message, tour_date, tour_time, updated_at, type } = item;

    const agentTableBody = () => {
      return (
        <tr key={id}>
          <td style={{ width: "10px", paddingRight: "0" }}>
            <div className="form-check">
              <input type="checkbox" className="form-check-input" />
              <label className="form-check-label"></label>
            </div>
          </td>
          <td>
            <div className="d-flex align-items-center gap-2">
              <div>
                <img src="/assets/images/users/avatar-1.jpg" alt="" style={{ objectFit: "cover", objectPosition: "top center" }} className="avatar-md full-rounded" />
              </div>
              <div>
                <a href="#!" className="text-dark fw-medium fs-15">
                  Shelly Barrett
                </a>
              </div>
            </div>
          </td>
          <td>Realter</td>
          <td>
            <a href="mailto:shellybarrett@mail.com">shellybarrett@mail.com</a>
          </td>
          <td>
            <a href="tel:(707) 972-3843">(707) 972-3843</a>
          </td>
          <td>
            <a href="tel:(707) 972-3843">(707) 972-3843</a>
          </td>
          <td className="action-btns">
            <div className="d-flex gap-2">
              <a href="#!" className="btn btn-light btn-sm">
                <Icon icon="solar:eye-broken" className="align-middle fs-18"></Icon>
              </a>
              <button type="button" className="btn btn-soft-danger btn-sm">
                <Icon icon="solar:trash-bin-minimalistic-2-broken" className="align-middle fs-18" />
              </button>
            </div>
          </td>
        </tr>
      );
    };

    const renderLeadDetailLayout = () => {
      return (
        <div className="lead-sidebar">
          <ul>
            <li>
              <span>Name</span> {name}
            </li>
            <li>
              <span>Phone</span> <a href="">{phone}</a>
            </li>
            <li>
              <span>Email</span> <a href="">{email}</a>
            </li>
          </ul>
          <div className="des">
            <span>Description</span> <p>{message}</p>
          </div>
        </div>
      );
    };

    return (
      <>
        {getModalLayout !== 2 && (
          <div id="popupSidebar" className="popup-sidebar">
            {renderLeadDetailLayout()}
          </div>
        )}
        <div id="popupContentGrid" className="popup-content-grid">
          <div id="activitySidebar" className="activity-bar">
            {activityTab === 0 && getModalLayout === 2 && renderLeadDetailLayout()}
            {activityTab === 1 && (
              <div className="lead-property">
                <div className="lead-property-header">
                  <h4>
                    5510 Eastside Calpella Rd <span>Ukiah, CA 95482</span>
                  </h4>
                  <h4>$499,000</h4>
                </div>
              </div>
            )}
            {activityTab === 2 && (
              <>
                <h4>Activity</h4>
                <div className="activity-bar-content">
                  <ul className="history-list">
                    <li className="mb-2">
                      Lead due date changed recently <span>Jul 16 at 6:59 pm</span>
                    </li>
                    <li className="mb-2">
                      Lead due date changed recently <span>Jul 16 at 6:59 pm</span>
                    </li>
                    <li className="mb-2">
                      Lead due date changed recently Lead due date changed recently <span>Jul 16 at 6:59 pm</span>
                    </li>
                    <li className="mb-2">
                      Lead due date changed recently <span>Jul 16 at 6:59 pm</span>
                    </li>
                    <li className="mb-2">
                      Lead due date changed recently Lead due date changed recently <span>Jul 16 at 6:59 pm</span>
                    </li>
                  </ul>
                </div>
              </>
            )}
            {activityTab === 3 && <h4>Tasks</h4>}
            {activityTab === 4 && (
              <>
                <h4>Agents</h4>
                <CustomTable tableHeaderList={agentHeaderList} tableBody={agentTableBody} />
              </>
            )}
            {activityTab === 5 && (
              <>
                <h4>Documents</h4>
                <div className="attachment-gallery">
                  <div className="attachment-gallery-item">
                    <figure>
                      <Image src="/assets/images/customer-bg.jpg" alt="Image" preview />
                    </figure>
                    <div className="content">
                      <p>Jul 10 at 10:00 am</p>
                      <span className="attachment-agent-name">RK</span>
                    </div>
                  </div>
                  <div className="attachment-gallery-item">
                    <figure>
                      <Image src="/assets/images/agent-1.png" alt="Image" preview />
                    </figure>
                    <div className="content">
                      <p>Jul 10 at 10:00 am</p>
                      <span className="attachment-agent-name">RK</span>
                    </div>
                  </div>
                </div>
              </>
            )}
            {activityTab === 6 && <h4>Calendar</h4>}
            {activityTab === 7 && <h4>Notes</h4>}
          </div>
        </div>
        <div className="activity-bar-ribbon">
          <div className="activity-list">
            {getModalLayout === 2 && (
              <button
                onClick={() => {
                  setActivityTab(0);
                }}
                className={activityTab === 0 ? "activityInfo-button active" : "activityInfo-button"}
              >
                <i className="ri-user-2-line"></i>
                <span>Lead</span>
              </button>
            )}
            <button
              onClick={() => {
                setActivityTab(1);
              }}
              className={activityTab === 1 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i className="ri-map-pin-line"></i>
              <span>Property</span>
            </button>
            <button
              onClick={() => {
                setActivityTab(3);
              }}
              className={activityTab === 3 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i className="ri-list-check-3"></i>
              <span>Tasks</span>
            </button>
            <button
              onClick={() => {
                setActivityTab(4);
              }}
              className={activityTab === 4 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i className="ri-group-line"></i>
              <span>Agents</span>
            </button>
            <button
              onClick={() => {
                setActivityTab(5);
              }}
              className={activityTab === 5 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i className="ri-article-line"></i>
              <span>Docs</span>
            </button>
            <button
              onClick={() => {
                setActivityTab(6);
              }}
              className={activityTab === 6 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i className="ri-calendar-2-line"></i>
              <span>Calendar</span>
            </button>
            <button
              onClick={() => {
                setActivityTab(2);
              }}
              className={activityTab === 2 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i className="ri-chat-4-line"></i>
              <span>Activity</span>
            </button>
            <button
              onClick={() => {
                setActivityTab(7);
              }}
              className={activityTab === 7 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i className="ri-add-line"></i>
              <span>Notes</span>
            </button>
          </div>
        </div>
      </>
    );
  };

  const leadsListView = () => {
    return leadsList.data.map((leads) => {
      const { id, listing_id, address, cityName, agentFirstName, agentLastName, property_image, name, phone, email, message, tour_date, tour_time, updated_at, type } = leads;
      const date = new Date(updated_at);
      const formatted = date.toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
      });

      function formatUSPhoneNumber(number) {
        const cleaned = String(number).replace(/\D/g, ""); // Remove non-digits
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

        if (match) {
          return `(${match[1]}) ${match[2]} ${match[3]}`;
        }

        return cleaned.slice(0, 10) || number; // fallback
      }

      return (
        <>
          <tr key={id}>
            <td style={{ width: "10px", paddingRight: "0" }}>
              <div className="form-check fs-13">
                <input type="checkbox" className="form-check-input" onChange={(e) => onHandleselectedList(id, e)} checked={selectedLeads.includes(id)} />
                <label className="form-check-label"></label>
              </div>
            </td>
            <td>
              <div className="d-flex align-items-center gap-2 item-overflow-2">
                <button
                  className="btn text-dark fw-medium fs-14"
                  onClick={() => {
                    const modifiedData = viewLead.filter((lead) => lead.id === id);
                    if (modifiedData.length === 0) {
                      setViewLead((prevState) => [...prevState, leads]);
                    }
                    // navigate(!leadIdArr ? "/leads/lid/" + id : !leadIdArr.includes(id.toString()) ? `/leads/${leadParam},${id}` : "");
                  }}
                >
                  {name}
                </button>
              </div>
            </td>
            <td>
              <a href={`mailto:${email}`}>{email}</a>
            </td>
            <td>
              <a href={`tel:+1${phone}`}>{formatUSPhoneNumber(phone)}</a>
            </td>
            <td>
              {/* <div className="d-flex align-items-center gap-2 item-overflow">
              <div>
                <Link to={`/property-details/${listing_id}`} className="text-dark fs-15">
                  {address}
                </Link>
              </div>
            </div> */}
              <Link to={`/property-details/${listing_id}`} className="">
                {address}
              </Link>
            </td>
            <td>{cityName}</td>
            <td>
              {agentFirstName}&nbsp;{agentLastName}
            </td>
            <td>{formatted}</td>
            {/*  <td className="action-btns">
            <div className="d-flex gap-1">
              <a href="#!" className="btn btn-light btn-sm" onClick={() => setSelectedContact(leads)}>
                <Icon icon="solar:eye-broken" className="align-middle fs-18"></Icon>
              </a>
              <button type="button" className="btn btn-soft-danger btn-sm" onClick={() => handleDelete(id)}>
                <Icon icon="solar:trash-bin-minimalistic-2-broken" className="align-middle fs-18" />
              </button>
              {type === 3 && (
                <a href="#!" className="btn btn-soft-warning btn-sm btn-tour">
                  <i className="ri-route-fill"></i>
                </a>
              )}
            </div> 
          </td> */}
          </tr>
        </>
      );
    });
  };

  const leadsLoadingView = () => {
    return (
      <tr className="loading-hover">
        <td className="property-loader preloader">
          <div className="loading">
            <div className="loading__letter">L</div>
            <div className="loading__letter">o</div>
            <div className="loading__letter">a</div>
            <div className="loading__letter">d</div>
            <div className="loading__letter">i</div>
            <div className="loading__letter">n</div>
            <div className="loading__letter">g</div>
            <div className="loading__letter">.</div>
            <div className="loading__letter">.</div>
            <div className="loading__letter">.</div>
          </div>
        </td>
      </tr>
    );
  };

  const noLeadsView = () => {
    return (
      <tr className="loading-hover">
        <td className="no-data-found">
          <Icon icon="solar:home-broken" className="fs-32 text-primary avatar-title"></Icon>
          No Leads Found
        </td>
      </tr>
    );
  };

  const renderView = () => {
    if (isLoading) {
      return leadsLoadingView();
    } else if (leadsList.status === "Not Found") {
      return noLeadsView();
    } else if (leadsList.status === "Success") {
      return leadsListView();
    }
  };

  return (
    <div className="page-content leads-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <Tooltip target=".custom-target-icon" tooltipOptions={{ event: "focus" }} />
              <h4 className="mb-0 fs-16">All Leads ({leadsList.pagination !== undefined ? leadsList.pagination.total : 0})</h4>

              <div className="page-title-box-content">
                {selectedLeads.length > 0 && (
                  <button type="button" className="page-title-btn custom-target-icon fs-18" data-pr-position="bottom" data-pr-tooltip="Delete" onClick={() => handleDelete(selectedLeads)}>
                    <i className="ri-delete-bin-line"></i>
                  </button>
                )}

                {selectedLeads.length === 1 && (
                  <button type="button" className="page-title-btn custom-target-icon fs-18" data-pr-position="bottom" data-pr-tooltip="Edit" data-bs-toggle="modal" data-bs-target="#editLead">
                    {/* <i className="ri-eye-line"></i> */}
                    <i className="ri-edit-2-line"></i>
                  </button>
                )}

                <button
                  type="button"
                  className="tour-button page-title-btn custom-target-icon"
                  data-pr-position="bottom"
                  data-pr-tooltip="Sort Tours"
                  onClick={() => {
                    setChangeType(3);
                  }}
                >
                  <i className="ri-route-fill fs-18"></i>
                </button>
                <button
                  type="button"
                  className="refresh-button page-title-btn custom-target-icon"
                  data-pr-position="bottom"
                  data-pr-tooltip="Refresh"
                  onClick={() => {
                    setFilteredValues({
                      searchValue: "",
                    });
                    setChangeType(0);
                    setDates(null);
                    setSelectedLeads([]);
                  }}
                >
                  <i className="ri-refresh-line fs-18"></i>
                </button>

                <form className="app-search">
                  <div className="position-relative">
                    <input
                      type="search"
                      className="form-control border-0"
                      placeholder="Search..."
                      autoComplete="off"
                      value={filteredValues.searchValue || ""}
                      onChange={filterGrid}
                      name="searchValue"
                    />
                    <i className="ri-search-line search-widget-icon"></i>
                    <button type="button" className="search-sort-link" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i className="ri-more-fill"></i>
                    </button>
                    <div className="dropdown lead-dropdown">
                      <div className="dropdown-menu dropdown-menu-end">
                        <span>Search In</span>
                        <a className="dropdown-item">
                          Lead Name <input type="checkbox" className="toggle-btn" defaultChecked />
                        </a>
                        <a className="dropdown-item">
                          Lead Phone <input type="checkbox" className="toggle-btn" defaultChecked />
                        </a>
                        <a className="dropdown-item">
                          Lead Email <input type="checkbox" className="toggle-btn" defaultChecked />
                        </a>
                      </div>
                    </div>
                  </div>
                </form>
                <Calendar
                  value={dates}
                  onChange={(e) => setDates(e.value)}
                  selectionMode="range"
                  readOnlyInput
                  hideOnRangeSelection
                  placeholder="MM DD"
                  dateFormat="M dd"
                  // dateFormat="M dd, yy"
                  showButtonBar
                  showIcon
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="table-responsive">
                <table className="table align-middle text-nowrap table-hover table-centered property-table">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th>
                        <div className="form-check fs-13">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedLeads(leadsList.data.map((lead) => lead.id));
                              } else {
                                setSelectedLeads([]);
                              }
                            }}
                            checked={leadsList?.data?.length > 0 && selectedLeads.length === leadsList.data.length}
                          />
                          <label className="form-check-label"></label>
                        </div>
                      </th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Property Name</th>
                      <th>City</th>
                      <th>Agent Name</th>
                      <th>Created Date</th>
                      {/* <th>Action</th> */}
                    </tr>
                  </thead>
                  <tbody>{renderView()}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="minimize-grid">
          {viewLead.length >= 1 &&
            viewLead.map((item) => (
              <CustomModal
                key={item.id}
                renderItem={() => renderLeadDetails(item)}
                title={item.name}
                visible={true}
                showLeftSidebarIcon={true}
                showCreateDate={true}
                showMoreIcon={true}
                createdDate={item.tour_date}
                showLayoutIcon={viewLead.length === 1}
                getModalLayout={setGetModalLayout}
                onHandleClose={() => {
                  const modifiedData = viewLead.filter((lead) => lead.id !== item.id);
                  setViewLead(modifiedData);
                }}
              />
            ))}
        </div>

        {/* {viewLead && <PopupTemplate visible={viewLead !== null} setVisible={setVisible} title={viewLead.name} created_date={viewLead.formatted} renderItem={renderLeadDetails} onClose={onLidClose} />} */}

        {selectedLeads.length === 1 && <EditLead selectedLeadId={selectedLeads} leadsList={leadsList} fetchData={fetchData} paginationObj={paginationObj} setSelectedLeads={setSelectedLeads} />}

        <div className="pagination-grid">
          <div className="pagination-new">
            <span className="pagination-count">
              {leadsList.pagination !== undefined ? leadsList.pagination.from : 1}-{leadsList.pagination !== undefined ? leadsList.pagination.to : 6} &nbsp;of &nbsp;
              {leadsList.pagination !== undefined ? leadsList.pagination.total : 0}
            </span>

            <button
              type="button"
              className="pagination-btn pagination-prev"
              onClick={() => {
                setPaginationObj((prevState) => ({ ...prevState, current: prevState.current - 1 }));
              }}
              disabled={paginationObj.current === 1}
            >
              <i className="ri-arrow-left-s-line"></i>
            </button>
            <button
              type="button"
              className="pagination-btn pagination-next"
              onClick={() => {
                setPaginationObj((prevState) => ({ ...prevState, current: prevState.current + 1 }));
              }}
              disabled={paginationObj.current === leadsList?.pagination?.last_page}
            >
              <i className="ri-arrow-right-s-line"></i>
            </button>
          </div>
          {/* <Pagination total={leadsList.pagination !== undefined ? leadsList.pagination.total : 0} pageSize={paginationObj.pageSize} current={paginationObj.current} onChange={paginationChange} /> */}
        </div>
      </div>
    </div>
  );
};

export default Leads;
